module.exports = __webpack_public_path__ + "static/media/play-solid.39673a55.svg";